import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, GraduationCap, Building2, Mail } from 'lucide-react';
import { SEO } from '../components/SEO';

export const NotFoundPage = () => {
  return (
    <main className="min-h-screen pt-32 pb-20 flex items-center" data-testid="not-found-page">
      <SEO
        title="Az oldal nem található"
        description="A keresett oldal nem található. Lépj vissza a főoldalra vagy nézd meg képzéseinket."
        path="/404"
        noindex
      />

      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-2xl mx-auto text-center"
        >
          <p className="text-brand-light-green font-mono text-sm tracking-widest uppercase mb-4">
            404
          </p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Ez az oldal nem található
          </h1>
          <p className="text-white/70 text-lg mb-10">
            Lehet, hogy elavult linket követtél vagy elgépelted az URL-t.
            Próbáld meg az alábbi oldalakat:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <Link
              to="/"
              className="glass-card p-6 hover:border-brand-light-green/50 transition-all group"
              data-testid="404-link-home"
            >
              <Home size={24} className="text-brand-light-green mb-3" />
              <p className="text-white font-medium group-hover:text-brand-light-green transition-colors">
                Főoldal
              </p>
              <p className="text-white/50 text-sm mt-1">
                Vissza a kezdőlapra
              </p>
            </Link>

            <Link
              to="/ingatlan"
              className="glass-card p-6 hover:border-brand-light-green/50 transition-all group"
              data-testid="404-link-realestate"
            >
              <GraduationCap size={24} className="text-brand-light-green mb-3" />
              <p className="text-white font-medium group-hover:text-brand-light-green transition-colors">
                Ingatlanközvetítői képzés
              </p>
              <p className="text-white/50 text-sm mt-1">
                Államilag elismert OKJ szakma
              </p>
            </Link>

            <Link
              to="/b2b"
              className="glass-card p-6 hover:border-brand-light-green/50 transition-all group"
              data-testid="404-link-b2b"
            >
              <Building2 size={24} className="text-brand-light-green mb-3" />
              <p className="text-white font-medium group-hover:text-brand-light-green transition-colors">
                Céges tréningek
              </p>
              <p className="text-white/50 text-sm mt-1">
                Vezetői és csapat-fejlesztés
              </p>
            </Link>

            <Link
              to="/jelentkezes"
              className="glass-card p-6 hover:border-brand-light-green/50 transition-all group"
              data-testid="404-link-registration"
            >
              <Mail size={24} className="text-brand-light-green mb-3" />
              <p className="text-white font-medium group-hover:text-brand-light-green transition-colors">
                Jelentkezés
              </p>
              <p className="text-white/50 text-sm mt-1">
                Foglalj helyet képzéseinken
              </p>
            </Link>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default NotFoundPage;
